// blogData.js
export const blogPosts = [
  {
    id: "post-1",
    image: "https://images.unsplash.com/photo-1541535650810-10d26f5c2ab3?auto=format&fit=crop&w=600&q=80",
    category: "Home Building Tips",
    date: "May 15, 2026",
    readTime: "5 min read",
    title: "How to Choose the Best Foundation for Houses in Uttar Pradesh",
    summary: "A simple guide detailing standard soil checks, brick grades, and high-quality concrete mixtures needed to prevent wall cracks during changing climate seasons.",
    details: "Building a home in Uttar Pradesh requires understanding local soil behaviors. This detailed guide breaks down why A-grade clay bricks, premium anti-rust steel bars (TMT), and correct cement ratios keep house foundations totally safe from damp water patches and floor shifting for over 50+ years."
  },
  {
    id: "post-2",
    image: "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&w=600&q=80",
    category: "Interior Trends",
    date: "April 28, 2026",
    readTime: "4 min read",
    title: "5 Smart Modular Kitchen Upgrades to Save Space in Modern Flats",
    summary: "Discover cost-effective wardrobe materials, soft-close cabinet drawers, and water-proof laminates perfectly built for Indian cooking layout styles.",
    details: "Modern Indian families need spacious, clean kitchen areas. By using hydraulic pull-out racks, moisture-proof commercial plywood, and granite platforms, you can maximize corner spaces effortlessly. Learn how professional interior designers choose long-lasting laminates that are easy to wipe clean."
  },
  {
    id: "post-3",
    image: "https://images.unsplash.com/photo-1527018601619-a508a2be00cd?auto=format&fit=crop&w=600&q=80",
    category: "Commercial Updates",
    date: "March 12, 2026",
    readTime: "7 min read",
    title: "Understanding Government Safety Rules for Petrol Pump Construction",
    summary: "A step-by-step breakdown of official safety boundaries, fire safety layouts, and pipe clearances required for successful commercial outlet operations.",
    details: "Setting up a commercial retail petroleum site requires strict alignment with safety norms. From ground level low-resistance earthing systems to non-porous concrete driveway structures, we review how to pass site inspections smoothly without facing unnecessary operational delays."
  }
];